import { DashboardMenuFeatures } from './DashboardMenuFeatures';
export class DashboardMenuController {
    static $inject = ['SegmentService', 'application'];
    constructor(SegmentService, application) {
        'ngInject';
        this.SegmentService = SegmentService;
        this.application = application;
        this.isShowingContactsJourney = false;
        this.isHidingContactsJourneyBetaTag = false;
    }
    async $onInit() {
        await this.checkFeatures();
    }
    async checkFeatures() {
        this.isShowingContactsJourney = await DashboardMenuFeatures.isShowingContactsJourney();
        this.isHidingContactsJourneyBetaTag = await DashboardMenuFeatures.isHidingContactsJourneyBetaTag();
    }
    trackOpenTab(trackEvent) {
        this.SegmentService.createApplicationTrack({
            trackEvent,
            application: this.application,
        });
    }
}
DashboardMenuController.$inject = ['SegmentService', 'application'];
